module.exports = __webpack_public_path__ + "img/lw.27636843.png";